import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, renderList as _renderList, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "desc-line" }
const _hoisted_3 = { class: "desc-line" }
const _hoisted_4 = {
  key: 0,
  class: "desc-line"
}
const _hoisted_5 = {
  key: 1,
  class: "desc-line color-danger"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 0,
  class: "flex-row"
}
const _hoisted_8 = { class: "custom-textarea" }
const _hoisted_9 = {
  key: 0,
  class: "custom-textarea danger ml20"
}
const _hoisted_10 = {
  key: 0,
  class: "flex-row"
}
const _hoisted_11 = { class: "flex-row-item preview-item" }
const _hoisted_12 = { class: "content-img-container" }
const _hoisted_13 = {
  key: 1,
  class: "video-preview"
}
const _hoisted_14 = ["src"]
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { class: "main-img-container" }
const _hoisted_17 = ["title"]
const _hoisted_18 = { class: "action-bar" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "main-img-container" }
const _hoisted_21 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_22 = { class: "content-img-container" }
const _hoisted_23 = ["title"]
const _hoisted_24 = { class: "content-img-container" }
const _hoisted_25 = { class: "content-img-container" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { key: 2 }
const _hoisted_30 = {
  key: 0,
  style: {"display":"block"}
}
const _hoisted_31 = {
  key: 0,
  class: "color-danger"
}
const _hoisted_32 = { key: 1 }
const _hoisted_33 = {
  key: 0,
  class: "bold"
}
const _hoisted_34 = { class: "code-info" }
const _hoisted_35 = { class: "container" }
const _hoisted_36 = { class: "image-slot" }
const _hoisted_37 = { class: "image-slot loading-slot" }
const _hoisted_38 = { class: "code-info-content" }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { class: "bold" }
const _hoisted_41 = {
  key: 1,
  class: "mt"
}
const _hoisted_42 = { class: "bold" }
const _hoisted_43 = {
  key: 2,
  class: "mt"
}
const _hoisted_44 = { class: "bold" }
const _hoisted_45 = { class: "action-list" }
const _hoisted_46 = { class: "action-list" }
const _hoisted_47 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { key: 1 }
const _hoisted_51 = { key: 2 }
const _hoisted_52 = { key: 3 }
const _hoisted_53 = { key: 4 }
const _hoisted_54 = { key: 5 }
const _hoisted_55 = { key: 6 }
const _hoisted_56 = { key: 7 }
const _hoisted_57 = { key: 8 }
const _hoisted_58 = { key: 9 }
const _hoisted_59 = { key: 10 }
const _hoisted_60 = { class: "dialog-footer" }
const _hoisted_61 = {
  key: 0,
  class: "tips",
  style: {"margin-left":"60px","margin-bottom":"20px"}
}
const _hoisted_62 = {
  key: 0,
  class: "action-bar"
}
const _hoisted_63 = {
  key: 0,
  style: {"display":"block"}
}
const _hoisted_64 = {
  key: 0,
  class: "color-danger"
}
const _hoisted_65 = { key: 1 }
const _hoisted_66 = {
  key: 0,
  class: "bold"
}
const _hoisted_67 = { class: "code-info" }
const _hoisted_68 = { class: "container" }
const _hoisted_69 = { class: "image-slot" }
const _hoisted_70 = { class: "image-slot loading-slot" }
const _hoisted_71 = { class: "code-info-content" }
const _hoisted_72 = { class: "bold" }
const _hoisted_73 = { class: "mt" }
const _hoisted_74 = { class: "bold" }
const _hoisted_75 = { class: "mt" }
const _hoisted_76 = { class: "bold" }
const _hoisted_77 = { class: "dialog-footer" }
const _hoisted_78 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_79 = { key: 0 }
const _hoisted_80 = { key: 1 }
const _hoisted_81 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_Picture = _resolveComponent("Picture")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_AutoDetailsImg = _resolveComponent("AutoDetailsImg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ((!_ctx.t || _ctx.t=='edit') && _ctx.formData.brand_id)
      ? (_openBlock(), _createBlock(_component_el_alert, {
          key: 0,
          class: "mb20",
          type: "warning"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _cache[118] || (_cache[118] = _createTextVNode("当前品牌还可提交 ")),
              _createElementVNode("b", null, _toDisplayString(_ctx.brandLimit), 1),
              _cache[119] || (_cache[119] = _createTextVNode(" 款商品"))
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (Boolean(_ctx.t) && _ctx.ProductO[_ctx.o]!=='已上线')
      ? (_openBlock(), _createBlock(_component_el_alert, {
          key: 1,
          class: "mb20",
          type: _ctx.formData.check_status === _ctx.CheckStatus['驳回'] || _ctx.formData.soldout_type ? 'error' : 'info'
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_3, "审核状态：" + _toDisplayString(_ctx.CheckStatus[_ctx.formData.check_status]), 1),
              (_ctx.formData.check_msg)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, "驳回原因：" + _toDisplayString(_ctx.formData.check_msg), 1))
                : _createCommentVNode("", true),
              (_ctx.formData.soldout_type)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createTextVNode("上次下架原因：" + _toDisplayString(_ctx.filterTypes[_ctx.formData.soldout_type]) + " ", 1),
                    (_ctx.formData.soldout_reson !== null)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, "(原因：" + _toDisplayString(_ctx.formData.soldout_reson) + ")", 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["type"]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_form, {
      class: "form",
      ref: "productForm",
      model: _ctx.formData,
      rules: _ctx.productRules,
      "label-width": "150px"
    }, {
      default: _withCtx(() => [
        (_ctx.t === 'view' || _ctx.t === 'check')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "品牌：",
              class: "inline-block_form-item",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.brand_name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.brand_name) = $event)),
                  disabled: "",
                  placeholder: "请选择品牌"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_el_form_item, {
              key: 1,
              class: _normalizeClass(_ctx.formData.save?.includes('brand_id') ? 'changed-el' : ''),
              "data-id": "brand_id",
              label: "品牌：",
              prop: "brand_id"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select_v2, {
                  modelValue: _ctx.formData.brand_id,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.brand_id) = $event)),
                  ref: "brandRef",
                  filterable: "",
                  clearable: "",
                  disabled: _ctx.t==='view' || Boolean(_ctx.t) && _ctx.formData.check_status !== 0,
                  options: _ctx.brandList,
                  props: _ctx.brandProps,
                  placeholder: "请选择品牌",
                  onChange: _ctx.onBrandChange
                }, null, 8, ["modelValue", "disabled", "options", "props", "onChange"])
              ]),
              _: 1
            }, 8, ["class"])),
        (_ctx.formData.brand_id == 103606)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 2,
              label: "SPU：",
              prop: "spu",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.spu,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.spu) = $event)),
                  placeholder: "请输入SPU编号",
                  disabled: _ctx.t === 'view' || _ctx.t === 'check'
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, {
          class: _normalizeClass(_ctx.formData.save?.includes('cat_id') ? 'changed-el' : ''),
          id: "tt",
          "data-id": "cat_id",
          label: "品类：",
          prop: "cat_id"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.formData.cat_id,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.cat_id) = $event)),
              filterable: "",
              placeholder: "请选择",
              disabled: _ctx.t==='view' || _ctx.t==='check' || _ctx.t==='edit' && _ctx.formData.check_status === 1
            }, {
              default: _withCtx(() => [
                (_ctx.formData.brand_cat_id==_ctx.BrandCat['蛋糕'] || _ctx.formData.brand_cat_id==_ctx.BrandCat['零食'] || Boolean(_ctx.t))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_el_option, {
                        label: "蛋糕",
                        value: _ctx.BrandCat['蛋糕']
                      }, null, 8, ["value"]),
                      _createVNode(_component_el_option, {
                        label: "零食",
                        value: _ctx.BrandCat['零食'],
                        disabled: !_ctx.groupIdArr.includes(56) && _ctx.source == '2' && new Date() < new Date('2026-03-18 23:59:59')
                      }, null, 8, ["value", "disabled"])
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.formData.brand_cat_id==_ctx.BrandCat['鲜花'] || Boolean(_ctx.t))
                  ? (_openBlock(), _createBlock(_component_el_option, {
                      key: 1,
                      label: "鲜花",
                      value: _ctx.BrandCat['鲜花']
                    }, null, 8, ["value"]))
                  : _createCommentVNode("", true),
                (_ctx.formData.brand_cat_id==_ctx.BrandCat['水果'] || Boolean(_ctx.t))
                  ? (_openBlock(), _createBlock(_component_el_option, {
                      key: 2,
                      label: "水果",
                      value: _ctx.BrandCat['水果']
                    }, null, 8, ["value"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_el_form_item, {
          label: "商品分类",
          prop: "cat_id3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_cascader, {
              placeholder: "请选择商品分类",
              props: _ctx.props,
              options: _ctx.options,
              modelValue: _ctx.formData.cat_id3,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.cat_id3) = $event)),
              onChange: _ctx.handleChange,
              clearable: "",
              filterable: "",
              disabled: _ctx.t==='check' && _ctx.o == 3 && _ctx.formData.cat_id2 == 111
            }, null, 8, ["props", "options", "modelValue", "onChange", "disabled"]),
            _cache[120] || (_cache[120] = _createElementVNode("div", {
              class: "suffix",
              style: {"margin-left":"10px","color":"#E6A23C"}
            }, "注：只有首次添加分类时可选择一级类目，日后修改仅可在二级类目中切换，请谨慎填选", -1))
          ]),
          _: 1
        }),
        ((_ctx.t === 'view' || _ctx.t === 'check') && (_ctx.formData.cat_id==_ctx.BrandCat['零食'] || (_ctx.formData.cat_id==_ctx.BrandCat['蛋糕'] && _ctx.formData.cat_id3 == '44')))
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 3,
              label: "二级品牌：",
              class: "inline-block_form-item",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.second_brand_name,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.second_brand_name) = $event)),
                  disabled: "",
                  placeholder: "请选择二级品牌"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : (_ctx.formData.cat_id==_ctx.BrandCat['零食'] || (_ctx.formData.cat_id==_ctx.BrandCat['蛋糕'] && _ctx.formData.cat_id3 == '44'))
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 4,
                class: _normalizeClass(_ctx.formData.save?.includes('brand_cat_id') ? 'changed-el' : ''),
                "data-id": "brand_cat_id",
                label: "二级品牌名称：",
                required: "",
                prop: "secondary_id"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select_v2, {
                    class: "filter-item",
                    disabled: Boolean(_ctx.oFormData.secondary_id) && (_ctx.t==='view' || _ctx.t==='check' || _ctx.t==='edit' && _ctx.formData.check_status === 1),
                    filterable: "",
                    modelValue: _ctx.formData.secondary_id,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.secondary_id) = $event)),
                    clearable: "",
                    options: _ctx.secondBrandList,
                    placeholder: "请选择二级品牌",
                    props: {
                        value: 'id',
                        label: 'name',
                        disabled: 'disabled'
                    }
                  }, null, 8, ["disabled", "modelValue", "options"])
                ]),
                _: 1
              }, 8, ["class"]))
            : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, {
          class: _normalizeClass(_ctx.formData.save?.includes('is_pre_sale') ? 'changed-el' : ''),
          "data-id": "is_pre_sale",
          label: "是否预售商品：",
          prop: "is_pre_sale"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: _ctx.formData.is_pre_sale,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.is_pre_sale) = $event)),
              disabled: _ctx.t==='view' || _ctx.t==='check'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, {
                  value: 0,
                  label: "否"
                }),
                _createVNode(_component_el_radio, {
                  value: 1,
                  label: "是"
                })
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }, 8, ["class"]),
        (_ctx.formData.is_pre_sale)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 5,
              class: _normalizeClass([_ctx.formData.save?.includes('is_pre_sale') ? 'changed-el' : '', "presale-item"]),
              "data-id": "pre_sale_date",
              label: "预售日期",
              prop: "pre_sale_date",
              style: {"width":"100%","display":"flex","justify-content":"space-around"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      class: "input-item",
                      modelValue: _ctx.formData.pre_sale_date,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.pre_sale_date) = $event)),
                      disabled: _ctx.t === 'view' || _ctx.t === 'check',
                      type: "date",
                      "disabled-date": _ctx.disabledPreSaleDate,
                      "value-format": "YYYY-MM-DD",
                      placeholder: "预售开始时间"
                    }, null, 8, ["modelValue", "disabled", "disabled-date"]),
                    _cache[121] || (_cache[121] = _createElementVNode("span", { class: "center" }, "-", -1)),
                    _createVNode(_component_el_date_picker, {
                      class: "input-item",
                      modelValue: _ctx.formData.yushou_end_date,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.yushou_end_date) = $event)),
                      disabled: _ctx.t === 'view' || _ctx.t === 'check',
                      type: "date",
                      "disabled-date": _ctx.disabledEndSaleDate,
                      placeholder: "预售解除时间",
                      "value-format": "YYYY-MM-DD"
                    }, null, 8, ["modelValue", "disabled", "disabled-date"]),
                    _cache[122] || (_cache[122] = _createElementVNode("div", {
                      class: "suffix",
                      style: {"margin-left":"10px","color":"#E6A23C"}
                    }, [
                      _createTextVNode(" 注： "),
                      _createElementVNode("div", null, "预售结束时间之后，48小时之内将快递发出如未按规定发出则被标记为延迟发货，务必注意！"),
                      _createElementVNode("div", null, "例：预售时间为 6月1日-6月10日，需在6月10之后的48小时之内，将预售商品发货")
                    ], -1))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        (_ctx.t === 'check' && _ctx.CheckStatus[_ctx.formData.check_status] === '审核中' || _ctx.source === '1')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 6,
              label: "蛋叔甄选：",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.formData.is_gross,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.is_gross) = $event)),
                  disabled: _ctx.t === 'view'
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, {
                      value: 0,
                      label: "否"
                    }),
                    _createVNode(_component_el_radio, {
                      value: 1,
                      label: "是"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, {
          class: _normalizeClass([_ctx.formData.save?.includes('title') ? 'changed-el' : '', "inline-block_form-item"]),
          "data-id": "title",
          label: "商品名称：",
          prop: "title"
        }, {
          default: _withCtx(() => [
            (_ctx.source === '1')
              ? (_openBlock(), _createBlock(_component_el_input, {
                  key: 0,
                  modelValue: _ctx.formData.title,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.title) = $event)),
                  modelModifiers: { trim: true },
                  type: "textarea",
                  maxlength: "30",
                  "show-word-limit": "",
                  disabled: _ctx.user_id != '5086',
                  onInput: _cache[12] || (_cache[12] = ($event: any) => (_ctx.formData.title = _ctx.filterSpecialChars(_ctx.formData.title)))
                }, null, 8, ["modelValue", "disabled"]))
              : (_openBlock(), _createBlock(_component_el_input, {
                  key: 1,
                  modelValue: _ctx.formData.title,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.title) = $event)),
                  modelModifiers: { trim: true },
                  type: "textarea",
                  maxlength: "30",
                  "show-word-limit": "",
                  disabled: _ctx.t==='view' || (Boolean(_ctx.t) && _ctx.formData.check_status !== _ctx.CheckStatus['未提交'] && _ctx.formData.check_status !== _ctx.CheckStatus['驳回']) || _ctx.formData.product_id > 0,
                  onInput: _cache[14] || (_cache[14] = ($event: any) => (_ctx.formData.title = _ctx.filterSpecialChars(_ctx.formData.title)))
                }, null, 8, ["modelValue", "disabled"])),
            (_ctx.t==='check' && _ctx.formData.title_new)
              ? (_openBlock(), _createBlock(_component_el_input, {
                  key: 2,
                  class: "danger ml20",
                  modelValue: _ctx.formData.title_new,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.title_new) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_el_form_item, {
          class: _normalizeClass(_ctx.formData.save?.includes('description') ? 'changed-el' : ''),
          "data-id": "description",
          label: "商品介绍：",
          prop: "description"
        }, {
          default: _withCtx(() => [
            (_ctx.t==='check')
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.formData.description), 1),
                  (_ctx.formData.description_new)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.formData.description_new), 1))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createBlock(_component_el_input, {
                  key: 1,
                  autosize: {minRows: 4},
                  resize: "both",
                  modelValue: _ctx.formData.description,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.description) = $event)),
                  modelModifiers: { trim: true },
                  type: "textarea",
                  "show-word-limit": "",
                  disabled: _ctx.t==='view' || _ctx.t==='check',
                  onInput: _cache[17] || (_cache[17] = ($event: any) => (_ctx.formData.description = _ctx.filterSpecialChars(_ctx.formData.description)))
                }, null, 8, ["modelValue", "disabled"]))
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_el_form_item, {
          class: _normalizeClass([_ctx.formData.save?.includes('poster') ? 'changed-el' : '', "poster-form-item"]),
          "data-id": "poster",
          label: "商品视频封面图：",
          required: [78, 90].includes(_ctx.formData.cat_id3)
        }, {
          default: _withCtx(() => [
            (_ctx.formData.poster)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_el_image, {
                        class: "main-img",
                        src: _ctx.formData.poster,
                        "preview-src-list": _ctx.formData.poster.split(','),
                        fit: "scale-down",
                        "hide-on-click-modal": "",
                        "append-to-body": "",
                        "z-index": 3000
                      }, null, 8, ["src", "preview-src-list"])
                    ]),
                    (_ctx.t!=='view' && _ctx.t!=='check')
                      ? (_openBlock(), _createBlock(_component_el_icon, {
                          key: 0,
                          class: "icon icon-delete",
                          onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.onImgRemove(0, 3)))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Delete)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : (_openBlock(), _createBlock(_component_el_upload, {
                  key: 1,
                  ref: "imageUpload",
                  disabled: _ctx.t==='view' || _ctx.t==='check',
                  class: "el-upload-list__item empty-item",
                  accept: ".jpg,.jpeg,.png",
                  action: "uploadUrl",
                  "before-upload": _ctx.onBeforeUpload,
                  "http-request": _ctx.uploadPosterRequest,
                  "show-file-list": false,
                  "list-type": "picture-card"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Plus)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["disabled", "before-upload", "http-request"])),
            _cache[123] || (_cache[123] = _createElementVNode("div", { class: "tips" }, "注：商品视频封面图宽高为 800*800，须大于150k 且 小于500k（上传商品视频时此项必填）", -1))
          ]),
          _: 1
        }, 8, ["class", "required"]),
        _createVNode(_component_el_form_item, {
          class: _normalizeClass([_ctx.formData.save?.includes('video') ? 'changed-el' : '', "poster-form-item"]),
          "data-id": "video",
          label: "商品视频：",
          required: [78, 90].includes(_ctx.formData.cat_id3)
        }, {
          default: _withCtx(() => [
            (!_ctx.formData.video)
              ? (_openBlock(), _createBlock(_component_el_upload, {
                  key: 0,
                  class: "upload-demo",
                  action: "none",
                  accept: ".mp4",
                  "before-upload": _ctx.onMp4BeforeUpload,
                  "http-request": _ctx.uploadMp4Request
                }, {
                  tip: _withCtx(() => _cache[125] || (_cache[125] = [
                    _createElementVNode("div", { class: "tips" }, "注：商品视频须大于150k 且 小于5M", -1)
                  ])),
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, { type: "primary" }, {
                      default: _withCtx(() => _cache[124] || (_cache[124] = [
                        _createTextVNode("选择文件")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["before-upload", "http-request"]))
              : _createCommentVNode("", true),
            (_ctx.formData.video)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("video", {
                    src: _ctx.formData.video,
                    controls: "",
                    width: "320",
                    height: "180",
                    class: "video-player"
                  }, " 您的浏览器不支持 video 标签。 ", 8, _hoisted_14),
                  (_ctx.t !== 'view' && _ctx.t !== 'check')
                    ? (_openBlock(), _createBlock(_component_el_icon, {
                        key: 0,
                        class: "icon-delete",
                        onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.onImgRemove(0, 4)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Delete)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.formData.video)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.video_name), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["class", "required"]),
        _createVNode(_component_el_form_item, {
          class: _normalizeClass([_ctx.formData.save?.includes('product_images_list') ? 'changed-el' : '', "image-form-item"]),
          "data-id": "product_images_list",
          label: "商品图：",
          required: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_draggable, {
              modelValue: _ctx.formData.product_images_list,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formData.product_images_list) = $event)),
              class: "flex-row"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.product_images_list, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "flex-row-item",
                    key: item.id
                  }, [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_el_image, {
                        class: "main-img",
                        src: item.url,
                        "preview-src-list": _ctx.mainPreviewList,
                        fit: "scale-down",
                        "hide-on-click-modal": "",
                        "append-to-body": "",
                        "z-index": 3000,
                        "initial-index": index
                      }, null, 8, ["src", "preview-src-list", "initial-index"])
                    ]),
                    _createElementVNode("div", {
                      class: "ellipsis",
                      title: item.file_name
                    }, _toDisplayString(item.file_name), 9, _hoisted_17),
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_el_radio, {
                        modelValue: _ctx.formData.image_id,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData.image_id) = $event)),
                        value: item.id,
                        disabled: _ctx.t==='view' || _ctx.t==='check',
                        label: "列表图"
                      }, null, 8, ["modelValue", "value", "disabled"]),
                      (_ctx.t!=='view' && _ctx.t!=='check')
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "color-primary",
                            style: {"cursor":"pointer"},
                            onClick: ($event: any) => (_ctx.onImgRemove(index, 1))
                          }, "删除", 8, _hoisted_19))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128)),
                _createVNode(_component_el_upload, {
                  ref: "imageUpload",
                  disabled: _ctx.t==='view' || _ctx.t==='check',
                  class: "el-upload-list__item empty-item",
                  accept: ".jpg,.jpeg,.png",
                  action: "uploadUrl",
                  "before-upload": _ctx.onBeforeUpload,
                  "http-request": _ctx.onImgUpload,
                  "file-list": _ctx.formData.product_images_list,
                  "show-file-list": false,
                  "list-type": "picture-card",
                  multiple: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Plus)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["disabled", "before-upload", "http-request", "file-list"])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _cache[126] || (_cache[126] = _createElementVNode("div", { class: "tips" }, "注：商品图宽高为 800*800，须大于50k 且 小于500k", -1))
          ]),
          _: 1
        }, 8, ["class"]),
        ((_ctx.formData.cat_id == 5 || _ctx.formData.cat_id3 == 44) && _ctx.formData.cat_id2 != 76)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 7,
              class: _normalizeClass([_ctx.formData.save?.includes('ingredient_img') ? 'changed-el' : '', "image-form-item"]),
              "data-id": "ingredient_img",
              label: "配料表图：",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_draggable, {
                  modelValue: _ctx.formData.ingredient_img,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formData.ingredient_img) = $event)),
                  class: "flex-row"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.ingredient_img, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "flex-row-item preview-item",
                        key: index
                      }, [
                        _createElementVNode("div", _hoisted_20, [
                          _createVNode(_component_el_image, {
                            class: "main-img",
                            src: item,
                            "preview-src-list": _ctx.ingredientPreviewList,
                            fit: "scale-down",
                            "hide-on-click-modal": "",
                            "append-to-body": "",
                            "z-index": 3000,
                            "initial-index": index
                          }, null, 8, ["src", "preview-src-list", "initial-index"])
                        ]),
                        (_ctx.t!=='view' && _ctx.t!=='check')
                          ? (_openBlock(), _createBlock(_component_el_icon, {
                              key: 0,
                              class: "icon",
                              onClick: ($event: any) => (_ctx.onIngredientRemove(index))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Delete)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    _createVNode(_component_el_upload, {
                      ref: "imageUpload",
                      disabled: _ctx.t==='view' || _ctx.t==='check',
                      class: "el-upload-list__item empty-item",
                      accept: ".jpg,.jpeg,.png",
                      action: "uploadUrl",
                      "before-upload": _ctx.onBeforeUpload,
                      "http-request": _ctx.onIngredientUpload,
                      "show-file-list": false,
                      "list-type": "picture-card",
                      multiple: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_Plus)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["disabled", "before-upload", "http-request"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _cache[127] || (_cache[127] = _createElementVNode("div", { class: "tips" }, "注：配料表图宽高为 800*800，须大于50k 且 小于500k", -1))
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, {
          class: _normalizeClass([_ctx.formData.save?.includes('content_images_list') ? 'changed-el' : '', "content-img-form-item"]),
          "data-id": "content_images_list",
          label: "详情图：",
          required: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_draggable, {
                modelValue: _ctx.formData.content_images_list,
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formData.content_images_list) = $event)),
                class: "flex-row"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.content_images_list, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "flex-row-item preview-item",
                      key: item.id
                    }, [
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_el_image, {
                          class: "content-img",
                          src: item.url,
                          "preview-src-list": _ctx.contentImgPreviewList,
                          fit: "scale-down",
                          "hide-on-click-modal": "",
                          "append-to-body": "",
                          "z-index": 3000,
                          "initial-index": index
                        }, null, 8, ["src", "preview-src-list", "initial-index"])
                      ]),
                      _createElementVNode("div", {
                        class: "ellipsis",
                        title: item.file_name
                      }, _toDisplayString(item.file_name), 9, _hoisted_23),
                      (_ctx.t!=='view' && _ctx.t!=='check')
                        ? (_openBlock(), _createBlock(_component_el_icon, {
                            key: 0,
                            class: "icon",
                            onClick: ($event: any) => (_ctx.onImgRemove(index, 2))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Delete)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128)),
                  (_ctx.isAuto !=1 || _ctx.formData.content_images_list.length == 0 || _ctx.isAddDetailImg)
                    ? (_openBlock(), _createBlock(_component_el_upload, {
                        key: 0,
                        ref: "imageUpload",
                        disabled: _ctx.t==='view' || _ctx.t==='check',
                        class: "el-upload-list__item empty-item",
                        accept: ".jpg,.jpeg,.png,.gif",
                        action: "uploadUrl",
                        "before-upload": _ctx.onContentBeforeUpload,
                        "http-request": _ctx.onContentImgUpload,
                        "file-list": _ctx.formData.content_images_list,
                        "show-file-list": false,
                        "list-type": "picture-card",
                        multiple: "",
                        style: {"width":"auto"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Plus)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["disabled", "before-upload", "http-request", "file-list"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              (_ctx.formData.content_images_list.length ==0  && _ctx.isAddDetailImg !=1 && _ctx.formData.cat_id == 1)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "success",
                    style: {"margin-left":"10px"},
                    disabled: _ctx.t=='view' || _ctx.t=='check',
                    onClick: _ctx.autoImg
                  }, {
                    default: _withCtx(() => _cache[128] || (_cache[128] = [
                      _createTextVNode(" 使用模板 ")
                    ])),
                    _: 1
                  }, 8, ["disabled", "onClick"]))
                : _createCommentVNode("", true)
            ]),
            _cache[129] || (_cache[129] = _createElementVNode("div", { class: "tips" }, "注：图片宽度为750/790，且不大于750k", -1))
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_el_form_item, {
          class: _normalizeClass(_ctx.formData.save?.includes('is_compare') ? 'changed-el' : ''),
          "data-id": "is_compare",
          label: "是否加入比价：",
          prop: "is_compare"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: _ctx.formData.is_compare,
              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formData.is_compare) = $event)),
              disabled: _ctx.t==='view' || _ctx.t==='check'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, {
                  value: 1,
                  label: "加入"
                }),
                _createVNode(_component_el_radio, {
                  value: 0,
                  label: "不加入"
                })
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }, 8, ["class"]),
        (_ctx.formData.is_compare == 1)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 8,
              class: _normalizeClass(_ctx.formData.save?.includes('is_compare') ? 'changed-el' : ''),
              "data-id": "is_compare",
              label: "比价链接：",
              prop: "compare_url"
            }, {
              default: _withCtx(() => [
                (_ctx.t==='view' || _ctx.t==='check')
                  ? (_openBlock(), _createBlock(_component_el_link, {
                      key: 0,
                      type: "primary",
                      href: _ctx.formData.compare_url,
                      target: "_blank",
                      style: {"display":"block","max-width":"400px","word-break":"break-all"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.formData.compare_url), 1)
                      ]),
                      _: 1
                    }, 8, ["href"]))
                  : (_openBlock(), _createBlock(_component_el_input, {
                      key: 1,
                      modelValue: _ctx.formData.compare_url,
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.formData.compare_url) = $event)),
                      modelModifiers: { trim: true },
                      type: "textarea",
                      placeholder: "优先京东自营及天猫超市，以上均无请添加京东旗舰店链接",
                      rows: 4,
                      "show-word-limit": "",
                      disabled: _ctx.t==='view' || _ctx.t==='check'
                    }, null, 8, ["modelValue", "disabled"]))
              ]),
              _: 1
            }, 8, ["class"]))
          : (_openBlock(), _createBlock(_component_el_form_item, {
              key: 9,
              class: _normalizeClass(_ctx.formData.save?.includes('compare_msg') ? 'changed-el' : ''),
              "data-id": "compare_msg",
              label: "不加入比价原因：",
              prop: "compare_msg"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.compare_msg,
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.formData.compare_msg) = $event)),
                  modelModifiers: { trim: true },
                  type: "textarea",
                  placeholder: "请输入不加入比价的原因",
                  maxlength: "255",
                  rows: 4,
                  "show-word-limit": "",
                  disabled: _ctx.t==='view' || _ctx.t==='check'
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["class"])),
        (_ctx.formData.is_compare == 1)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 10,
              label: "比价价格：",
              prop: "merchant_compare_price",
              class: _normalizeClass(_ctx.formData.save?.includes('merchant_compare_price') ? 'changed-el' : '')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.merchant_compare_price,
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.formData.merchant_compare_price) = $event)),
                  modelModifiers: { number: true },
                  onInput: _cache[28] || (_cache[28] = val => _ctx.formData.merchant_compare_price = val.replace(/[^\d.]/g, '')),
                  disabled: _ctx.t==='view' || (_ctx.source === '1' && _ctx.t==='edit' && _ctx.o == 1) || _ctx.t==='check' || (_ctx.o == 2 && _ctx.source === '1')
                }, {
                  append: _withCtx(() => _cache[130] || (_cache[130] = [
                    _createTextVNode("元")
                  ])),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        (_ctx.formData.is_compare == 1)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 11,
              label: "比价销量：",
              prop: "merchant_compare_num",
              class: _normalizeClass(_ctx.formData.save?.includes('merchant_compare_num') ? 'changed-el' : ''),
              style: _normalizeStyle({
                backgroundColor: _ctx.shouldHighlight ? '#fef0f0' : ''})
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.merchant_compare_num,
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.formData.merchant_compare_num) = $event)),
                  modelModifiers: { number: true },
                  onInput: _cache[30] || (_cache[30] = val => _ctx.formData.merchant_compare_num = val.replace(/[^\d.]/g, '')),
                  disabled: _ctx.t==='view' || (_ctx.source === '1' && _ctx.t==='edit' && _ctx.o == 1) || _ctx.t==='check' || (_ctx.o == 2 && _ctx.source === '1')
                }, {
                  append: _withCtx(() => _cache[131] || (_cache[131] = [
                    _createTextVNode("个")
                  ])),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["class", "style"]))
          : _createCommentVNode("", true),
        (_ctx.formData.is_compare == 1)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 12,
              label: "比价截图：",
              class: _normalizeClass(["content-img-form-item compare_image", _ctx.formData.save?.includes('merchant_compare_image') ? 'changed-el' : '']),
              prop: "merchant_compare_image"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_draggable, {
                  modelValue: _ctx.formData.merchant_compare_image,
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.formData.merchant_compare_image) = $event)),
                  class: "flex-row"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.merchant_compare_image, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "flex-row-item preview-item",
                        key: index
                      }, [
                        _createElementVNode("div", _hoisted_24, [
                          _createVNode(_component_el_image, {
                            class: "content-img",
                            src: item.pasteImg,
                            "preview-src-list": _ctx.MerchantCompareImgPreviewList,
                            fit: "scale-down",
                            "hide-on-click-modal": "",
                            "append-to-body": "",
                            "z-index": 3000
                          }, null, 8, ["src", "preview-src-list"])
                        ]),
                        ((_ctx.source == '2' && _ctx.t !=='view') || (_ctx.source === '1' && _ctx.o == 2) || (_ctx.t ==='edit' && _ctx.o == 3 && _ctx.formData.merchant_compare_image.lenght == 0))
                          ? (_openBlock(), _createBlock(_component_el_icon, {
                              key: 0,
                              class: "icon",
                              onClick: ($event: any) => (_ctx.onRemoveImg(index,1))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Delete)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                ((_ctx.source == '2' && _ctx.t !=='view') || (_ctx.source === '1' && _ctx.o == 2) || (_ctx.t ==='edit' && _ctx.o == 3 && _ctx.formData.merchant_compare_image.length == 0))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      type: "text",
                      onPaste: _cache[32] || (_cache[32] = ($event: any) => (_ctx.onPaste($event,1))),
                      style: {"width":"100px","height":"33px","color":"#5a5af1","text-align":"center","border":"1px solid #eaeaea"}
                    }, " ctrl+v粘贴图片 ", 32))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        (_ctx.t=='check' || (_ctx.t=='view' && _ctx.o == 3 && _ctx.pasteImgPreviewList.length > 0) || (_ctx.t=='edit' && _ctx.o == 3 && _ctx.pasteImgPreviewList.length > 0))
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 13,
              label: "审核人员比价图片：",
              class: "content-img-form-item"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_draggable, {
                  modelValue: _ctx.formData.pasteimg_path,
                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.formData.pasteimg_path) = $event)),
                  class: "flex-row"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.pasteimg_path, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "flex-row-item preview-item",
                        key: index
                      }, [
                        _createElementVNode("div", _hoisted_25, [
                          _createVNode(_component_el_image, {
                            class: "content-img",
                            src: item.pasteImg,
                            "preview-src-list": _ctx.pasteImgPreviewList,
                            fit: "scale-down",
                            "hide-on-click-modal": "",
                            "append-to-body": "",
                            "z-index": 3000
                          }, null, 8, ["src", "preview-src-list"])
                        ]),
                        (_ctx.t=='check' && _ctx.formData.check_status == 1)
                          ? (_openBlock(), _createBlock(_component_el_icon, {
                              key: 0,
                              class: "icon",
                              onClick: ($event: any) => (_ctx.onRemoveImg(index,0))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Delete)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                (_ctx.t=='check' && _ctx.formData.check_status == 1)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      type: "text",
                      onPaste: _cache[34] || (_cache[34] = ($event: any) => (_ctx.onPaste($event,0))),
                      style: {"width":"100px","height":"33px","color":"#5a5af1","text-align":"center","border":"1px solid #eaeaea"}
                    }, " 点击粘贴图片 ", 32))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        ((_ctx.t=='view' && _ctx.o == 3) || _ctx.t=='check' || (_ctx.t=='edit' && _ctx.o == 3))
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 14,
              label: "审核人员比价链接：",
              prop: "kf_compare_url"
            }, {
              default: _withCtx(() => [
                ((_ctx.t=='view' && _ctx.o == 3) || (_ctx.t=='edit' && _ctx.o == 3))
                  ? (_openBlock(), _createBlock(_component_el_link, {
                      key: 0,
                      type: "primary",
                      href: _ctx.formData.kf_compare_url,
                      target: "_blank",
                      style: {"display":"block","max-width":"400px","word-break":"break-all"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.formData.kf_compare_url), 1)
                      ]),
                      _: 1
                    }, 8, ["href"]))
                  : (_openBlock(), _createBlock(_component_el_input, {
                      key: 1,
                      modelValue: _ctx.formData.kf_compare_url,
                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.formData.kf_compare_url) = $event)),
                      modelModifiers: { trim: true },
                      type: "textarea",
                      placeholder: "请输入比价链接",
                      rows: 4,
                      "show-word-limit": ""
                    }, null, 8, ["modelValue"]))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        ((_ctx.t=='view' && _ctx.o == 3) || _ctx.t=='check' || (_ctx.t=='edit' && _ctx.o == 3))
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 15,
              label: "审核人员比价价格：",
              prop: "kf_compare_price"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.kf_compare_price,
                  "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.formData.kf_compare_price) = $event)),
                  disabled: (_ctx.t=='view' && _ctx.o == 3) || (_ctx.t=='edit' && _ctx.o == 3)
                }, {
                  append: _withCtx(() => _cache[132] || (_cache[132] = [
                    _createTextVNode("元")
                  ])),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.formData.cat_id != _ctx.BrandCat['蛋糕'])
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 16,
              class: _normalizeClass(_ctx.formData.save?.includes('invoice_type') ? 'changed-el' : ''),
              "data-id": "invoice_type",
              label: "发票类型：",
              prop: "invoice_type"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.formData.invoice_type,
                  "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.formData.invoice_type) = $event)),
                  placeholder: "此项请留空或与商务、运营确认后再填写",
                  clearable: "",
                  disabled: _ctx.t==='view' || _ctx.t==='check'
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "专票",
                      value: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "普票",
                      value: 2
                    }),
                    _createVNode(_component_el_option, {
                      label: "无票",
                      value: 3
                    }),
                    _createVNode(_component_el_option, {
                      label: "其他",
                      value: 4
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        (_ctx.formData.cat_id != _ctx.BrandCat['蛋糕'])
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 17,
              class: _normalizeClass(_ctx.formData.save?.includes('tax_Point') ? 'changed-el' : ''),
              "data-id": "tax_Point",
              label: "税点：",
              prop: "tax_Point"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.formData.tax_Point,
                  "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.formData.tax_Point) = $event)),
                  placeholder: "此项请留空或与商务、运营确认后再填写",
                  clearable: "",
                  disabled: _ctx.t==='view' || _ctx.t==='check'
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "1",
                      value: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "3",
                      value: 3
                    }),
                    _createVNode(_component_el_option, {
                      label: "6",
                      value: 6
                    }),
                    _createVNode(_component_el_option, {
                      label: "9",
                      value: 9
                    }),
                    _createVNode(_component_el_option, {
                      label: "13",
                      value: 13
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, {
          class: _normalizeClass([_ctx.formData.save?.includes('specs_list') ? 'changed-el' : '', "table-form-item"]),
          "data-id": "specs_list",
          label: "规格：",
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table, {
              data: _ctx.formData.specs_list,
              border: "",
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "id",
                  label: "ID",
                  fixed: ""
                }),
                _createVNode(_component_el_table_column, {
                  prop: "name",
                  label: "规格",
                  fixed: ""
                }),
                _createVNode(_component_el_table_column, {
                  prop: "description",
                  label: "规格描述"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "spec_img",
                  label: "规格图片"
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.spec_img)
                      ? (_openBlock(), _createBlock(_component_el_image, {
                          key: 0,
                          class: "content-img",
                          src: scope.row.spec_img,
                          "zoom-rate": 1.2,
                          fit: "cover",
                          "hide-on-click-modal": "",
                          "append-to-body": "",
                          onClick: ($event: any) => (_ctx.srcList = [scope.row.spec_img]),
                          "z-index": 3000,
                          "preview-teleported": true,
                          "preview-src-list": _ctx.srcList,
                          style: {"width":"50px","height":"40px"}
                        }, null, 8, ["src", "onClick", "preview-src-list"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "tastes",
                  label: "口味/颜色",
                  width: "90"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "market_price",
                  label: "市场价"
                }),
                (_ctx.t=='check')
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 0,
                      prop: "original_price",
                      label: "原售价"
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_table_column, {
                  prop: "price",
                  label: "售价"
                }),
                (_ctx.formData.cat_id != _ctx.BrandCat['蛋糕'])
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 1,
                      prop: "stock",
                      label: "库存",
                      width: "90"
                    }, {
                      default: _withCtx(({ row }) => [
                        (row.stock == '-9999999')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, "无限量"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(row.stock), 1))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_table_column, {
                  prop: "original_clearing_price",
                  label: "原结算价"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "clearing_price",
                  label: "结算价"
                }),
                (_ctx.formData.cat_id == 1 && _ctx.is_kd != 1)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 2,
                      prop: "gift",
                      label: "配套餐具"
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_table_column, {
                  prop: "sku",
                  label: "SKU"
                }),
                (_ctx.formData.cat_id == 5 && _ctx.formData.cat_id2 != 76)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 3,
                      prop: "is_import",
                      label: "进口商品"
                    }, {
                      default: _withCtx((scope) => [
                        (scope.row.is_import == 1)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: _normalizeClass(_ctx.t==='check'?'red_import':'')
                            }, "是", 2))
                          : (scope.row.is_import == 2)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_28, "自组组合"))
                            : (_openBlock(), _createElementBlock("span", _hoisted_29, "否"))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.formData.cat_id == 5 && _ctx.formData.cat_id2 != 76)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 4,
                      label: "69码"
                    }, {
                      default: _withCtx(({ row }) => [
                        _createElementVNode("p", null, _toDisplayString(row.product_code), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.formData.cat_id == 5 && _ctx.formData.cat_id2 != 76)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 5,
                      label: "69码商品信息",
                      width: "300"
                    }, {
                      default: _withCtx(({ row }) => [
                        (row.product_code)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                              (!row.code_name && !row.code_spec_name && !row.code_brand_name && !row.code_firm_name && !row.code_img)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_31, " 未找到相关商品 "))
                                : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                    (row.code_name)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(row.code_name), 1))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_34, [
                                      _createElementVNode("div", _hoisted_35, [
                                        _createVNode(_component_el_image, {
                                          src: row.code_img,
                                          "preview-src-list": [row.code_img],
                                          "zoom-rate": 1.2,
                                          fit: "cover",
                                          "hide-on-click-modal": "",
                                          "z-index": 3000,
                                          "preview-teleported": true,
                                          "append-to-body": "",
                                          class: "code-img"
                                        }, {
                                          error: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_36, [
                                              _createVNode(_component_el_icon, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_Picture)
                                                ]),
                                                _: 1
                                              }),
                                              _cache[133] || (_cache[133] = _createElementVNode("span", null, "暂无数据", -1))
                                            ])
                                          ]),
                                          placeholder: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_37, [
                                              _createVNode(_component_el_icon, { class: "is-loading" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_Loading)
                                                ]),
                                                _: 1
                                              }),
                                              _cache[134] || (_cache[134] = _createElementVNode("span", null, "加载中...", -1))
                                            ])
                                          ]),
                                          _: 2
                                        }, 1032, ["src", "preview-src-list"])
                                      ]),
                                      _createElementVNode("div", _hoisted_38, [
                                        (row.code_spec_name)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                              _cache[135] || (_cache[135] = _createTextVNode("规格：")),
                                              _createElementVNode("span", _hoisted_40, _toDisplayString(row.code_spec_name), 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (row.code_brand_name)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                              _cache[136] || (_cache[136] = _createTextVNode("品牌：")),
                                              _createElementVNode("span", _hoisted_42, _toDisplayString(row.code_brand_name), 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (row.code_firm_name)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                              _cache[137] || (_cache[137] = _createTextVNode("企业：")),
                                              _createElementVNode("span", _hoisted_44, _toDisplayString(row.code_firm_name), 1)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ]))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_table_column, {
                  prop: "shop_discount",
                  label: "规格折扣"
                }),
                _createVNode(_component_el_table_column, { label: "状态" }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.row.deleted ? '下架' : '上架'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "操作",
                  fixed: "right"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("div", _hoisted_45, [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        size: "small",
                        onClick: _withModifiers(($event: any) => (_ctx.editSpec(scope.row, scope.$index)), ["prevent"]),
                        disabled: _ctx.t==='view' || _ctx.t==='check'
                      }, {
                        default: _withCtx(() => _cache[138] || (_cache[138] = [
                          _createTextVNode("编辑")
                        ])),
                        _: 2
                      }, 1032, ["onClick", "disabled"]),
                      (scope.row.id && _ctx.t!='view' && _ctx.t!='check')
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            disabled: scope.row.stock == 0 && scope.row.deleted,
                            title: scope.row.stock == 0 && scope.row.deleted ? '库存为0，不可操作上架' : '',
                            class: "mt8",
                            type: "primary",
                            size: "small",
                            onClick: _withModifiers(($event: any) => (_ctx.updateSpecStatus(scope.row)), ["prevent"])
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(scope.row.deleted ? '上架' : '下架'), 1)
                            ]),
                            _: 2
                          }, 1032, ["disabled", "title", "onClick"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"]),
            _createVNode(_component_el_button, {
              class: "mt15",
              type: "primary",
              disabled: _ctx.t==='view' || _ctx.t==='check',
              onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.showAddSpec()))
            }, {
              default: _withCtx(() => _cache[139] || (_cache[139] = [
                _createTextVNode("添加")
              ])),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }, 8, ["class"]),
        (_ctx.formData.cat_id == _ctx.BrandCat['蛋糕'] && _ctx.canShowAttachment)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 18,
              class: _normalizeClass([_ctx.formData.save?.includes('charges_list') ? 'changed-el' : '', "table-form-item"]),
              "data-id": "charges_list",
              label: "收费附件："
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table, {
                  data: _ctx.formData.charges_list,
                  style: {"width":"100%"},
                  border: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      prop: "name",
                      label: "附件名称"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "unity",
                      label: "计量单位"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "price",
                      label: "单价"
                    }),
                    _createVNode(_component_el_table_column, { label: "附件图标" }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("div", {
                          class: _normalizeClass(['icon', _ctx.ChargeType[scope.row.type]])
                        }, null, 2)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "sku",
                      label: "SKU"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "status",
                      label: "状态"
                    }, {
                      default: _withCtx((scope) => [
                        _createTextVNode(_toDisplayString(scope.row.status ? '上架': '下架'), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, { label: "操作" }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("div", _hoisted_46, [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            size: "small",
                            onClick: _withModifiers(($event: any) => (_ctx.editCharge(scope.row, scope.$index)), ["prevent"]),
                            disabled: _ctx.t==='view' || _ctx.t==='check'
                          }, {
                            default: _withCtx(() => _cache[140] || (_cache[140] = [
                              _createTextVNode("编辑")
                            ])),
                            _: 2
                          }, 1032, ["onClick", "disabled"]),
                          _createVNode(_component_el_button, {
                            size: "small",
                            type: "primary",
                            onClick: ($event: any) => (_ctx.changeStatus(scope.row.id, scope.row.status))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(scope.row.status == 0 ? '上架' : '下架'), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["data"]),
                _createVNode(_component_el_button, {
                  class: "mt15",
                  type: "primary",
                  disabled: _ctx.t==='view' || _ctx.t==='check',
                  onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.showAddCharge()))
                }, {
                  default: _withCtx(() => _cache[141] || (_cache[141] = [
                    _createTextVNode("添加")
                  ])),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, {
          class: _normalizeClass(_ctx.formData.save?.includes('extra_data') ? 'changed-el' : ''),
          "data-id": "extra_data",
          label: "原料：",
          prop: "extra_data.material",
          required: _ctx.formData.cat_id==`${_ctx.BrandCat['蛋糕']}`
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              type: "textarea",
              modelValue: _ctx.formData.extra_data.material,
              "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.formData.extra_data.material) = $event)),
              modelModifiers: { trim: true },
              maxlength: "50",
              disabled: _ctx.t==='view' || _ctx.t==='check',
              onInput: _cache[42] || (_cache[42] = ($event: any) => (_ctx.formData.extra_data.material = _ctx.filterSpecialChars(_ctx.formData.extra_data.material)))
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }, 8, ["class", "required"]),
        _createVNode(_component_el_form_item, {
          class: _normalizeClass(_ctx.formData.save?.includes('extra_data') ? 'changed-el' : ''),
          "data-id": "extra_data",
          label: "口感："
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              type: "textarea",
              modelValue: _ctx.formData.extra_data.taste,
              "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.formData.extra_data.taste) = $event)),
              modelModifiers: { trim: true },
              maxlength: "50",
              disabled: _ctx.t==='view' || _ctx.t==='check',
              onInput: _cache[44] || (_cache[44] = ($event: any) => (_ctx.formData.extra_data.taste = _ctx.filterSpecialChars(_ctx.formData.extra_data.taste)))
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_el_form_item, {
          class: _normalizeClass(_ctx.formData.save?.includes('extra_data') ? 'changed-el' : ''),
          "data-id": "extra_data",
          label: "甜度："
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: _ctx.formData.extra_data.sweetness,
              "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.formData.extra_data.sweetness) = $event)),
              disabled: _ctx.t==='view' || _ctx.t==='check'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, {
                  value: 1,
                  label: "1"
                }),
                _createVNode(_component_el_radio, {
                  value: 2,
                  label: "2"
                }),
                _createVNode(_component_el_radio, {
                  value: 3,
                  label: "3"
                }),
                _createVNode(_component_el_radio, {
                  value: 4,
                  label: "4"
                }),
                _createVNode(_component_el_radio, {
                  value: 5,
                  label: "5"
                }),
                _createVNode(_component_el_radio, {
                  value: 6,
                  label: "6"
                }),
                _createVNode(_component_el_radio, {
                  value: 7,
                  label: "7"
                }),
                _createVNode(_component_el_radio, {
                  value: 8,
                  label: "8"
                }),
                _createVNode(_component_el_radio, {
                  value: 9,
                  label: "9"
                }),
                _createVNode(_component_el_radio, {
                  value: 10,
                  label: "10"
                })
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_el_form_item, {
          class: _normalizeClass(_ctx.formData.save?.includes('extra_data') ? 'changed-el' : ''),
          "data-id": "extra_data",
          label: "存储条件：",
          prop: "extra_data.storage"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              type: "textarea",
              modelValue: _ctx.formData.extra_data.storage,
              "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.formData.extra_data.storage) = $event)),
              modelModifiers: { trim: true },
              maxlength: "8",
              "show-word-limit": "",
              disabled: _ctx.t==='view' || _ctx.t==='check',
              onInput: _cache[47] || (_cache[47] = ($event: any) => (_ctx.formData.extra_data.storage = _ctx.filterSpecialChars(_ctx.formData.extra_data.storage)))
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_el_form_item, {
          class: _normalizeClass(_ctx.formData.save?.includes('extra_data') ? 'changed-el' : ''),
          "data-id": "extra_data",
          label: "推荐理由：",
          prop: "extra_data.introduce"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              type: "textarea",
              modelValue: _ctx.formData.extra_data.introduce,
              "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.formData.extra_data.introduce) = $event)),
              modelModifiers: { trim: true },
              maxlength: "8",
              "show-word-limit": "",
              disabled: _ctx.t==='view' || _ctx.t==='check',
              placeholder: "新鲜现做/顺丰冷链/动物奶油/松软可口/匠心工艺/低糖低脂/健康美味轻负担...",
              onInput: _cache[49] || (_cache[49] = ($event: any) => (_ctx.formData.extra_data.introduce = _ctx.filterSpecialChars(_ctx.formData.extra_data.introduce)))
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_el_form_item, {
          class: _normalizeClass(_ctx.formData.save?.includes('extra_data') ? 'changed-el' : ''),
          "data-id": "extra_data",
          label: "保质期：",
          prop: "extra_data.expiry_days"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.formData.extra_data.expiry_days,
              "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.formData.extra_data.expiry_days) = $event)),
              disabled: _ctx.t==='view' || _ctx.t==='check',
              onInput: _cache[51] || (_cache[51] = ($event: any) => (_ctx.formData.extra_data.expiry_days=_ctx.formData.extra_data.expiry_days.replace(/[^0-9]/g,''))),
              placeholder: "请输入保质期"
            }, {
              append: _withCtx(() => _cache[142] || (_cache[142] = [
                _createTextVNode("天")
              ])),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_el_form_item, {
          class: _normalizeClass(_ctx.formData.save?.includes('labels') ? 'changed-el' : ''),
          "data-id": "labels",
          label: "标签：",
          prop: "classify_label",
          ref: "label_name-form-item"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_cascader, {
              disabled: _ctx.t==='view',
              class: "filter-item",
              placeholder: "请选择标签（可多选）",
              ref: "cardRef",
              props: _ctx.ClassifyProps,
              options: _ctx.ClassifyOptions,
              modelValue: _ctx.formData.classify_label,
              "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.formData.classify_label) = $event)),
              "collapse-tags-tooltip": "",
              "max-collapse-tags": 3,
              "collapse-tags": "",
              clearable: "",
              multiple: "",
              filterable: ""
            }, {
              default: _withCtx(({ node, ClassifyOptions }) => [
                _createElementVNode("span", {
                  class: _normalizeClass({ 'no-checkbox': node.level ==1 })
                }, _toDisplayString(node.label), 3)
              ]),
              _: 1
            }, 8, ["disabled", "props", "options", "modelValue"])
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_el_form_item, {
          class: _normalizeClass(_ctx.formData.save?.includes('labels') ? 'changed-el' : ''),
          "data-id": "labels",
          label: "标签组：",
          prop: "group_label",
          ref: "label_name-form-item"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_cascader, {
              disabled: _ctx.t==='view',
              class: "filter-item",
              placeholder: "请选择标签（可多选）",
              ref: "cardRef",
              props: _ctx.ClassifyProps,
              options: _ctx.GroupOptions,
              modelValue: _ctx.formData.group_label,
              "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.formData.group_label) = $event)),
              "collapse-tags-tooltip": "",
              "max-collapse-tags": 3,
              "collapse-tags": "",
              clearable: "",
              multiple: "",
              filterable: ""
            }, null, 8, ["disabled", "props", "options", "modelValue"])
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_el_form_item, {
          class: _normalizeClass(_ctx.formData.save?.includes('delivery_addr') ? 'changed-el' : ''),
          "data-id": "delivery_addr",
          label: "发货地址：",
          prop: "delivery_addr"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_cascader, {
              class: "filter-item",
              placeholder: "请选择城市",
              ref: "cardRef",
              props: _ctx.propCitys,
              options: _ctx.optionCitys,
              modelValue: _ctx.formData.delivery_addr,
              "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.formData.delivery_addr) = $event)),
              modelModifiers: { trim: true },
              "collapse-tags-tooltip": "",
              clearable: "",
              multiple: "",
              filterable: ""
            }, null, 8, ["props", "options", "modelValue"])
          ]),
          _: 1
        }, 8, ["class"]),
        (_ctx.formData.cat_id3 == 44 || _ctx.formData.cat_id2 == 61 || (_ctx.is_kd == 1 && _ctx.formData.cat_id ==1))
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 19,
              class: _normalizeClass(_ctx.formData.save?.includes('reserve_type') ? 'changed-el' : ''),
              "data-id": "reserve_type",
              label: "储存方式:：",
              prop: "reserve_type"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.formData.reserve_type,
                  "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.formData.reserve_type) = $event)),
                  disabled: _ctx.t==='view' || _ctx.t==='check'
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, {
                      value: 1,
                      label: "冷冻"
                    }),
                    _createVNode(_component_el_radio, {
                      value: 2,
                      label: "冷藏"
                    }),
                    _createVNode(_component_el_radio, {
                      value: 3,
                      label: "避光常温"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        (_ctx.formData.cat_id===_ctx.BrandCat['蛋糕'])
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 20,
              class: _normalizeClass(_ctx.formData.save?.includes('is_greeting') ? 'changed-el' : ''),
              "data-id": "is_greeting",
              label: "祝福语：",
              prop: "is_greeting"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.formData.is_greeting,
                  "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.formData.is_greeting) = $event)),
                  disabled: _ctx.t==='view' || _ctx.t==='check'
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, {
                      value: 0,
                      label: "支持"
                    }),
                    _createVNode(_component_el_radio, {
                      value: 1,
                      label: "不支持"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        (_ctx.formData.cat_id===_ctx.BrandCat['蛋糕'] && _ctx.formData.is_greeting==0)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 21,
              class: _normalizeClass(_ctx.formData.save?.includes('greeting_num') ? 'changed-el' : ''),
              "data-id": "greeting_num",
              label: "祝福语限制：",
              prop: "greeting_num"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.formData.greeting_num,
                  "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.formData.greeting_num) = $event)),
                  placeholder: "请选择祝福语字数限制",
                  disabled: _ctx.t==='view' || _ctx.t==='check'
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "请选择祝福语长度限制",
                      value: 0
                    }),
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(20, (item) => {
                      return _createVNode(_component_el_option, {
                        label: item,
                        value: item,
                        key: item
                      }, null, 8, ["label", "value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, {
          class: _normalizeClass(_ctx.formData.save?.includes('label_name') ? 'changed-el' : ''),
          "data-id": "label_name",
          label: "商品标签：",
          prop: "label_name",
          ref: "label_name-form-item"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_checkbox_group, {
              modelValue: _ctx.formData.label_name,
              "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.formData.label_name) = $event)),
              disabled: _ctx.t==='view' || _ctx.t==='check',
              style: {"width":"500px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox, {
                  label: "同城配送",
                  value: "同城配送"
                }),
                _createVNode(_component_el_checkbox, {
                  label: "全国包邮",
                  value: "全国包邮"
                }),
                _createVNode(_component_el_checkbox, {
                  label: "当日达",
                  value: "当日达"
                }),
                _createVNode(_component_el_checkbox, {
                  label: "次日达",
                  value: "次日达"
                }),
                _createVNode(_component_el_checkbox, {
                  label: "全国配送",
                  value: "全国配送"
                }),
                _createVNode(_component_el_checkbox, {
                  label: "门店自提",
                  value: "门店自提"
                }),
                _createVNode(_component_el_checkbox, {
                  label: "京东",
                  value: "京东"
                }),
                _createVNode(_component_el_checkbox, {
                  label: "顺丰",
                  value: "顺丰"
                })
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"]),
            (_ctx.showNotice)
              ? (_openBlock(), _createElementBlock("p", _hoisted_47, "注意：发货订单 仅限勾选的快递，请谨慎 ！"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["class"]),
        (_ctx.is_tc == 1)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 22,
              class: _normalizeClass(_ctx.formData.save?.includes('wuliu_cats') ? 'changed-el' : ''),
              "data-id": "wuliu_cats",
              label: "快递：",
              prop: "wuliu_cats"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.formData.wuliu_cats,
                  "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.formData.wuliu_cats) = $event)),
                  multiple: "",
                  filterable: "",
                  clearable: "",
                  placeholder: "请选择快递"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.LogisticsList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.cat_name,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, {
          class: _normalizeClass(_ctx.formData.save?.includes('special_tag') ? 'changed-el' : ''),
          "data-id": "special_tag",
          label: "特殊节日标签：",
          prop: "special_tag",
          ref: "special_tag-form-item"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: _ctx.formData.special_tag,
              "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.formData.special_tag) = $event)),
              disabled: _ctx.t==='view' || _ctx.t==='check',
              style: {"width":"500px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, {
                  label: "非节日特定产品",
                  value: "非节日特定产品"
                }),
                _createVNode(_component_el_radio, {
                  label: "年货节",
                  value: "年货节"
                }),
                _createVNode(_component_el_radio, {
                  label: "中秋节",
                  value: "中秋节"
                }),
                _createVNode(_component_el_radio, {
                  label: "端午节",
                  value: "端午节"
                }),
                _createVNode(_component_el_radio, {
                  label: "情人节",
                  value: "情人节"
                })
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }, 8, ["class"]),
        (_ctx.source === '2')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 23,
              class: _normalizeClass(_ctx.formData.save?.includes('is_voluntarily') ? 'changed-el' : ''),
              "data-id": "is_voluntarily",
              label: "定时上架：",
              prop: "is_voluntarily"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.formData.is_voluntarily,
                  "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.formData.is_voluntarily) = $event)),
                  disabled: _ctx.t==='view'
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, {
                      value: 1,
                      label: "是"
                    }),
                    _createVNode(_component_el_radio, {
                      value: 0,
                      label: "否"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["class"]))
          : (_openBlock(), _createBlock(_component_el_form_item, {
              key: 24,
              "data-id": "is_voluntarily",
              label: "是否上架：",
              prop: "is_voluntarily"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.formData.status,
                  "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.formData.status) = $event)),
                  disabled: _ctx.t==='view'
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, {
                      value: 1,
                      label: "是"
                    }),
                    _createVNode(_component_el_radio, {
                      value: 0,
                      label: "否"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            })),
        (_ctx.formData.is_voluntarily)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 25,
              class: _normalizeClass(_ctx.formData.save?.includes('voluntarily_time') ? 'changed-el' : ''),
              "data-id": "voluntarily_time",
              label: "上架时间：",
              prop: "voluntarily_time"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.formData.voluntarily_time,
                  "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.formData.voluntarily_time) = $event)),
                  disabled: _ctx.t==='view',
                  type: "date",
                  "disabled-date": _ctx.disabledVoluntarilyDate,
                  "value-format": "YYYY-MM-DD",
                  placeholder: "上架日期"
                }, null, 8, ["modelValue", "disabled", "disabled-date"]),
                _createVNode(_component_el_select, {
                  modelValue: _ctx.hour,
                  "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.hour) = $event)),
                  placeholder: "请选择时间",
                  disabled: _ctx.t==='view'
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hourList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item,
                        label: item,
                        value: item,
                        disabled: _ctx.voluntarilyTimeDisabled(item)
                      }, null, 8, ["label", "value", "disabled"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        (_ctx.t==='check')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 26,
              class: _normalizeClass(_ctx.formData.save?.includes('remark') ? 'changed-el' : ''),
              "data-id": "remark",
              label: "备注"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "textarea",
                  modelValue: _ctx.formData.remark,
                  "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.formData.remark) = $event)),
                  modelModifiers: { trim: true }
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        (_ctx.t==='check')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 27,
              class: _normalizeClass(_ctx.formData.save?.includes('is_choiceness') ? 'changed-el' : ''),
              "data-id": "is_choiceness",
              prop: "is_choiceness",
              label: "是否为精选商品"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.formData.is_choiceness,
                  "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.formData.is_choiceness) = $event)),
                  disabled: _ctx.t==='view'
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, {
                      value: 0,
                      label: "否"
                    }),
                    _createVNode(_component_el_radio, {
                      value: 1,
                      label: "是"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, {
          class: _normalizeClass(_ctx.formData.save?.includes('status') ? 'changed-el' : ''),
          "data-id": "status"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 10 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createTextVNode("商品状态：" + _toDisplayString(_ctx.formData.status ? '上架' : '下架'), 1)
                  ]),
                  _: 1
                }),
                (_ctx.formData.status ==0 )
                  ? (_openBlock(), _createBlock(_component_el_col, {
                      key: 0,
                      span: 8
                    }, {
                      default: _withCtx(() => [
                        _cache[143] || (_cache[143] = _createTextVNode("下架类型： ")),
                        (_ctx.formData.soldout_type && _ctx.formData.soldout_type.length == 0 || _ctx.formData.soldout_type==null || _ctx.formData.soldout_type === 'null' || _ctx.formData.soldout_type === 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_48, "其他"))
                          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.formData.soldout_type, (type) => {
                              return (_openBlock(), _createElementBlock("span", { key: type }, [
                                (type === '1')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_49, "商品溢价"))
                                  : (type === '2')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_50, "折扣不合格"))
                                    : (type === '3')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_51, "信息有误"))
                                      : (type === '4')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_52, "质量问题"))
                                        : (type === '5')
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_53, "口感不佳"))
                                          : (type === '6')
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_54, "延迟发货"))
                                            : (type === '7')
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_55, "品牌资质过期"))
                                              : (type === '8')
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_56, "自行下架"))
                                                : (type === '9')
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_57, "库存不足"))
                                                  : (type === '10')
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_58, "永久下架13"))
                                                    : _createCommentVNode("", true),
                                (type !== _ctx.formData.soldout_type[_ctx.formData.soldout_type.length - 1])
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_59, ", "))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.formData.status ==0 && _ctx.formData.soldout_reson)
                  ? (_openBlock(), _createBlock(_component_el_col, {
                      key: 1,
                      span: 8
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("下架原因： " + _toDisplayString(_ctx.formData.soldout_reson), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (_ctx.source != '1')
              ? (_openBlock(), _createBlock(_component_el_row, {
                  key: 0,
                  gutter: 10
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createTextVNode("制单人：" + _toDisplayString(_ctx.formData.admin_name), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 6 }, {
                      default: _withCtx(() => [
                        _createTextVNode("创建时间：" + _toDisplayString(_ctx.formData.created_at), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.source != '1')
              ? (_openBlock(), _createBlock(_component_el_row, {
                  key: 1,
                  gutter: 10
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createTextVNode("审核人：" + _toDisplayString(_ctx.formData.check_status !=0 ? _ctx.formData.check_name : ''), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 6 }, {
                      default: _withCtx(() => [
                        _createTextVNode("审核时间：" + _toDisplayString(_ctx.formData.check_time), 1)
                      ]),
                      _: 1
                    }),
                    (_ctx.t=='check')
                      ? (_openBlock(), _createBlock(_component_el_col, {
                          key: 0,
                          span: 6
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("上次驳回原因：" + _toDisplayString(_ctx.formData.check_remark ||  '--'), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            ( _ctx.t==='check' && _ctx.formData.check_status===1)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _cache[67] || (_cache[67] = ($event: any) => (_ctx.onCheck(1)))
                  }, {
                    default: _withCtx(() => _cache[144] || (_cache[144] = [
                      _createTextVNode("通过并上架")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    type: "danger",
                    onClick: _cache[68] || (_cache[68] = ($event: any) => (_ctx.rejectDialog = true))
                  }, {
                    default: _withCtx(() => _cache[145] || (_cache[145] = [
                      _createTextVNode("驳回")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    type: "warning",
                    onClick: _cache[69] || (_cache[69] = ($event: any) => (_ctx.openDialog()))
                  }, {
                    default: _withCtx(() => _cache[146] || (_cache[146] = [
                      _createTextVNode("通过并下架")
                    ])),
                    _: 1
                  })
                ], 64))
              : (_ctx.t!=='view' && _ctx.t!=='check')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_ctx.source === '2')
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "primary",
                          onClick: _cache[70] || (_cache[70] = ($event: any) => (_ctx.submitForm(0)))
                        }, {
                          default: _withCtx(() => _cache[147] || (_cache[147] = [
                            _createTextVNode("暂存")
                          ])),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_button, {
                      type: "success",
                      onClick: _cache[71] || (_cache[71] = ($event: any) => (_ctx.submitForm(1)))
                    }, {
                      default: _withCtx(() => _cache[148] || (_cache[148] = [
                        _createTextVNode("提交")
                      ])),
                      _: 1
                    })
                  ], 64))
                : _createCommentVNode("", true),
            _createVNode(_component_el_button, {
              type: "info",
              plain: "",
              onClick: _cache[72] || (_cache[72] = ($event: any) => (_ctx.router.go(-1)))
            }, {
              default: _withCtx(() => _cache[149] || (_cache[149] = [
                _createTextVNode("返回")
              ])),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _createVNode(_component_el_dialog, {
      title: "下架原因",
      modelValue: _ctx.productShelfShow,
      "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => ((_ctx.productShelfShow) = $event)),
      "before-close": _ctx.onProductShelfShow
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_60, [
          _createVNode(_component_el_button, { onClick: _ctx.onProductShelfShow }, {
            default: _withCtx(() => _cache[150] || (_cache[150] = [
              _createTextVNode("取 消")
            ])),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "success",
            onClick: _cache[75] || (_cache[75] = ($event: any) => (_ctx.onCheck(2)))
          }, {
            default: _withCtx(() => _cache[151] || (_cache[151] = [
              _createTextVNode("确 定")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.shelf,
          "label-width": "120px",
          ref: "shelfProductForm",
          rules: _ctx.shelfRule
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "下架类型",
              prop: "soldout_type"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  style: {"width":"300px"},
                  filterable: "",
                  modelValue: _ctx.shelf.soldout_type,
                  "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((_ctx.shelf.soldout_type) = $event)),
                  placeholder: "下架类型",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      value: _ctx.offTypes['商品溢价'],
                      label: "商品溢价"
                    }, null, 8, ["value"]),
                    _createVNode(_component_el_option, {
                      value: _ctx.offTypes['折扣不合格'],
                      label: "折扣不合格"
                    }, null, 8, ["value"]),
                    _createVNode(_component_el_option, {
                      value: _ctx.offTypes['信息有误'],
                      label: "信息有误"
                    }, null, 8, ["value"]),
                    _createVNode(_component_el_option, {
                      value: _ctx.offTypes['质量问题'],
                      label: "质量问题"
                    }, null, 8, ["value"]),
                    _createVNode(_component_el_option, {
                      value: _ctx.offTypes['口感不佳'],
                      label: "口感不佳"
                    }, null, 8, ["value"]),
                    _createVNode(_component_el_option, {
                      value: _ctx.offTypes['整改下架'],
                      label: "整改下架"
                    }, null, 8, ["value"]),
                    _createVNode(_component_el_option, {
                      value: _ctx.offTypes['永久下架'],
                      label: "永久下架"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "下架原因" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "textarea",
                  modelValue: _ctx.shelf.soldout_reson,
                  "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((_ctx.shelf.soldout_reson) = $event)),
                  modelModifiers: { trim: true },
                  placeholder: "下架原因",
                  maxlength: "100",
                  rows: 4,
                  "show-word-limit": "",
                  style: {"width":"400px"},
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"]),
    _createVNode(_component_el_dialog, {
      title: "驳回原因",
      modelValue: _ctx.rejectDialog,
      "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event: any) => ((_ctx.rejectDialog) = $event)),
      "before-close": _ctx.onRejectDialogClose
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "info",
          plain: "",
          onClick: _ctx.onRejectDialogClose
        }, {
          default: _withCtx(() => _cache[152] || (_cache[152] = [
            _createTextVNode("取 消")
          ])),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          type: "danger",
          onClick: _cache[78] || (_cache[78] = ($event: any) => (_ctx.onCheck(3)))
        }, {
          default: _withCtx(() => _cache[153] || (_cache[153] = [
            _createTextVNode("驳 回")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_input, {
            type: "textarea",
            modelValue: _ctx.check_msg,
            "onUpdate:modelValue": _cache[77] || (_cache[77] = ($event: any) => ((_ctx.check_msg) = $event)),
            modelModifiers: { trim: true },
            maxlength: "100",
            rows: 4,
            "show-word-limit": "",
            placeholder: "请输入驳回原因"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"]),
    _createVNode(_component_el_dialog, {
      title: "添加规格信息",
      modelValue: _ctx.specDialog,
      "onUpdate:modelValue": _cache[106] || (_cache[106] = ($event: any) => ((_ctx.specDialog) = $event)),
      width: "50%",
      "before-close": _ctx.onSpecDialogClose
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_77, [
          _createVNode(_component_el_button, {
            onClick: _cache[104] || (_cache[104] = ($event: any) => (_ctx.onSpecDialogClose()))
          }, {
            default: _withCtx(() => _cache[167] || (_cache[167] = [
              _createTextVNode("取 消")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[105] || (_cache[105] = ($event: any) => (_ctx.submitSpec()))
          }, {
            default: _withCtx(() => _cache[168] || (_cache[168] = [
              _createTextVNode("确 定")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.specOptions,
          inline: true,
          ref: "addSpecFrom",
          "label-width": "120px",
          rules: _ctx.specRules
        }, {
          default: _withCtx(() => [
            (Boolean(_ctx.specOptions.is_activity))
              ? (_openBlock(), _createElementBlock("div", _hoisted_61, "注：该规格目前正处于促销活动中，如需调整价格请联系蛋叔运营"))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              label: "规格名称：",
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.specOptions.name,
                  "onUpdate:modelValue": _cache[80] || (_cache[80] = ($event: any) => ((_ctx.specOptions.name) = $event)),
                  autocomplete: "off",
                  clearable: "",
                  placeholder: "15个汉字 或 30个字母 以内",
                  disabled: _ctx.specOptions.id!=='' && (_ctx.formData.product_id>0 || _ctx.ProductO[_ctx.o]==='已上线'),
                  onBlur: _cache[81] || (_cache[81] = ($event: any) => (_ctx.specOptions.name = _ctx.clearBr(_ctx.specOptions.name)))
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            (_ctx.formData.cat_id == 1 && _ctx.is_kd != 1)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  label: "配套餐具：",
                  prop: "gift"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.specOptions.gift,
                      "onUpdate:modelValue": _cache[82] || (_cache[82] = ($event: any) => ((_ctx.specOptions.gift) = $event)),
                      maxlength: "20",
                      "show-word-limit": ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              class: "content-img-form-item",
              label: "规格图："
            }, {
              default: _withCtx(() => [
                _createVNode(_component_draggable, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      (_ctx.specOptions.spec_img)
                        ? (_openBlock(), _createBlock(_component_el_image, {
                            key: 0,
                            class: "content-img",
                            src: _ctx.specOptions.spec_img,
                            fit: "scale-down",
                            "hide-on-click-modal": "",
                            onClick: _cache[83] || (_cache[83] = ($event: any) => (_ctx.srcList = [_ctx.specOptions.spec_img])),
                            "preview-src-list": _ctx.srcList,
                            "append-to-body": "",
                            "z-index": 3000,
                            style: {"width":"150px"}
                          }, null, 8, ["src", "preview-src-list"]))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.specOptions.spec_img)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                          _createElementVNode("span", {
                            class: "color-primary",
                            style: {"cursor":"pointer"},
                            onClick: _cache[84] || (_cache[84] = ($event: any) => (_ctx.removeSpecImage(_ctx.specOptions.id)))
                          }, "删除")
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.specOptions.spec_img)
                      ? (_openBlock(), _createBlock(_component_el_upload, {
                          key: 1,
                          ref: "imageUpload",
                          class: "el-upload-list__item empty-item",
                          accept: ".jpg,.jpeg,.png",
                          action: "uploadUrl",
                          "before-upload": _ctx.onBeforeUpload,
                          "http-request": _ctx.onImgUploadSpecs,
                          "show-file-list": false,
                          "list-type": "picture-card",
                          style: {"width":"auto"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_Plus)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["before-upload", "http-request"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _cache[154] || (_cache[154] = _createElementVNode("div", { class: "tips" }, "注：规格图宽高为 800*800，须大于150k 且 小于500k", -1))
              ]),
              _: 1
            }),
            (_ctx.user_id == 8150)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 2,
                  label: "商品单位：",
                  prop: "unit"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.specOptions.unit,
                      "onUpdate:modelValue": _cache[85] || (_cache[85] = ($event: any) => ((_ctx.specOptions.unit) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.formData.cat_id != _ctx.BrandCat['蛋糕'])
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 3,
                  label: "库存：",
                  class: "stock-item"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "number",
                      style: {"width":"130px"},
                      modelValue: _ctx.specOptions.stock,
                      "onUpdate:modelValue": _cache[86] || (_cache[86] = ($event: any) => ((_ctx.specOptions.stock) = $event)),
                      disabled: _ctx.specOptions.isUnlimited,
                      onInput: _ctx.handleStockInput
                    }, null, 8, ["modelValue", "disabled", "onInput"]),
                    _createVNode(_component_el_checkbox, {
                      modelValue: _ctx.specOptions.isUnlimited,
                      "onUpdate:modelValue": _cache[87] || (_cache[87] = ($event: any) => ((_ctx.specOptions.isUnlimited) = $event)),
                      disabled: _ctx.specOptions.stock !== '' && !_ctx.specOptions.isUnlimited,
                      style: {"margin-left":"10px","font-weight":"400"},
                      onChange: _ctx.handleUnlimitedChange
                    }, {
                      default: _withCtx(() => _cache[155] || (_cache[155] = [
                        _createTextVNode("无限量")
                      ])),
                      _: 1
                    }, 8, ["modelValue", "disabled", "onChange"]),
                    _cache[156] || (_cache[156] = _createElementVNode("div", { class: "tips" }, "注：无库存限制，请根据商品库存自行控制上架", -1))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              label: "市场价：",
              prop: "market_price"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.specOptions.market_price,
                  "onUpdate:modelValue": _cache[88] || (_cache[88] = ($event: any) => ((_ctx.specOptions.market_price) = $event)),
                  autocomplete: "off",
                  disabled: Boolean(_ctx.specOptions.is_activity),
                  placeholder: "不能小于售价",
                  onInput: _cache[89] || (_cache[89] = ($event: any) => (_ctx.specOptions.market_price = _ctx.formatPrecision(_ctx.specOptions.market_price)))
                }, {
                  append: _withCtx(() => _cache[157] || (_cache[157] = [
                    _createTextVNode("元")
                  ])),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "售价：",
              prop: "price"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.specOptions.price,
                  "onUpdate:modelValue": _cache[90] || (_cache[90] = ($event: any) => ((_ctx.specOptions.price) = $event)),
                  placeholder: "不能大于市场价",
                  disabled: Boolean(_ctx.specOptions.is_activity),
                  onInput: _cache[91] || (_cache[91] = ($event: any) => (_ctx.specOptions.price = _ctx.formatPrecision(_ctx.specOptions.price)))
                }, {
                  append: _withCtx(() => _cache[158] || (_cache[158] = [
                    _createTextVNode("元")
                  ])),
                  _: 1
                }, 8, ["modelValue", "disabled"]),
                _createVNode(_component_el_alert, {
                  type: "error",
                  title: "修改售价会导致商品下架，请慎重操作！",
                  style: {"padding":"0"},
                  closable: false
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "口味或者颜色：",
              prop: "tastes"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.specOptions.tastes,
                  "onUpdate:modelValue": _cache[92] || (_cache[92] = ($event: any) => ((_ctx.specOptions.tastes) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "结算价：",
              prop: "clearing_price"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.specOptions.clearing_price,
                  "onUpdate:modelValue": _cache[93] || (_cache[93] = ($event: any) => ((_ctx.specOptions.clearing_price) = $event)),
                  placeholder: "保留2位小数",
                  disabled: Boolean(_ctx.specOptions.is_activity) || _ctx.specOptions.sc_num >=3,
                  onInput: _cache[94] || (_cache[94] = ($event: any) => (_ctx.specOptions.clearing_price = _ctx.formatPrecision(_ctx.specOptions.clearing_price)))
                }, {
                  append: _withCtx(() => _cache[159] || (_cache[159] = [
                    _createTextVNode("元")
                  ])),
                  _: 1
                }, 8, ["modelValue", "disabled"]),
                _createVNode(_component_el_alert, {
                  type: "error",
                  title: "修改结算价会导致商品下架，请慎重操作！",
                  style: {"padding":"0"},
                  closable: false
                }),
                (_ctx.formData.cat_id == 5 && _ctx.formData.cat_id2 != 76 && _ctx.t == 'edit' && !_ctx.specOptions.product_code_add && _ctx.specOptions.id)
                  ? (_openBlock(), _createBlock(_component_el_alert, {
                      key: 0,
                      type: "warning",
                      title: `本月剩余 ${3 - Number(_ctx.specOptions.sc_num)} 次改价次数`,
                      style: {"padding":"0","margin-top":"5px"},
                      closable: false
                    }, null, 8, ["title"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "SKU：" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.specOptions.sku,
                  "onUpdate:modelValue": _cache[95] || (_cache[95] = ($event: any) => ((_ctx.specOptions.sku) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (_ctx.formData.cat_id == 5 && _ctx.formData.cat_id2 != 76)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 4,
                  label: "进口商品："
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio_group, {
                      style: {"width":"200px"},
                      modelValue: _ctx.specOptions.is_import,
                      "onUpdate:modelValue": _cache[96] || (_cache[96] = ($event: any) => ((_ctx.specOptions.is_import) = $event)),
                      onChange: _ctx.handleImportChange
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio, {
                          value: 0,
                          label: "否"
                        }),
                        _createVNode(_component_el_radio, {
                          value: 1,
                          label: "是"
                        }),
                        _createVNode(_component_el_radio, {
                          value: 2,
                          label: "自组组合"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.formData.cat_id == 5 && _ctx.formData.cat_id2 != 76 && !_ctx.specOptions.is_import)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 5,
                  label: "69码：",
                  prop: "product_code"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      "show-word-limit": "",
                      maxlength: "13",
                      modelValue: _ctx.specOptions.product_code,
                      "onUpdate:modelValue": _cache[97] || (_cache[97] = ($event: any) => ((_ctx.specOptions.product_code) = $event)),
                      onInput: _cache[98] || (_cache[98] = ($event: any) => (_ctx.specOptions.product_code=_ctx.specOptions.product_code.replace(/[^0-9]/g,'')))
                    }, null, 8, ["modelValue"]),
                    (_ctx.specOptions.product_code)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                          (!_ctx.specOptions.code_name && !_ctx.specOptions.code_spec_name && !_ctx.specOptions.code_brand_name && !_ctx.specOptions.code_firm_name && !_ctx.specOptions.code_img)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_64, " 未找到相关商品 "))
                            : (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                (_ctx.specOptions.code_name)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_66, _toDisplayString(_ctx.specOptions.code_name), 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_67, [
                                  _createElementVNode("div", _hoisted_68, [
                                    _createVNode(_component_el_image, {
                                      class: "code-img",
                                      src: _ctx.specOptions.code_img,
                                      "preview-src-list": _ctx.specOptions.code_img.split(','),
                                      fit: "scale-down",
                                      "hide-on-click-modal": "",
                                      "append-to-body": "",
                                      "z-index": 3000
                                    }, {
                                      error: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_69, [
                                          _createVNode(_component_el_icon, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_Picture)
                                            ]),
                                            _: 1
                                          }),
                                          _cache[160] || (_cache[160] = _createElementVNode("span", null, "暂无数据", -1))
                                        ])
                                      ]),
                                      placeholder: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_70, [
                                          _createVNode(_component_el_icon, { class: "is-loading" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_Loading)
                                            ]),
                                            _: 1
                                          }),
                                          _cache[161] || (_cache[161] = _createElementVNode("span", null, "加载中...", -1))
                                        ])
                                      ]),
                                      _: 1
                                    }, 8, ["src", "preview-src-list"])
                                  ]),
                                  _createElementVNode("div", _hoisted_71, [
                                    _createElementVNode("div", null, [
                                      _cache[162] || (_cache[162] = _createTextVNode("规格：")),
                                      _createElementVNode("span", _hoisted_72, _toDisplayString(_ctx.specOptions.code_spec_name), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_73, [
                                      _cache[163] || (_cache[163] = _createTextVNode("品牌：")),
                                      _createElementVNode("span", _hoisted_74, _toDisplayString(_ctx.specOptions.code_brand_name), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_75, [
                                      _cache[164] || (_cache[164] = _createTextVNode("企业：")),
                                      _createElementVNode("span", _hoisted_76, _toDisplayString(_ctx.specOptions.code_firm_name), 1)
                                    ])
                                  ])
                                ])
                              ]))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              label: "规格折扣：",
              prop: "shop_discount"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.specOptions.shop_discount,
                  "onUpdate:modelValue": _cache[99] || (_cache[99] = ($event: any) => ((_ctx.specOptions.shop_discount) = $event)),
                  readonly: "",
                  placeholder: "保留2位小数"
                }, null, 8, ["modelValue"]),
                (_ctx.source != 1)
                  ? (_openBlock(), _createBlock(_component_el_alert, {
                      key: 0,
                      type: "error",
                      title: `规格折扣不能大于${_ctx.minDiscount}！`,
                      style: {"padding":"0"},
                      closable: false
                    }, null, 8, ["title"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (_ctx.formData.cat_id == 1)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 6,
                  label: "规格描述：",
                  prop: "description"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.specOptions.description,
                      "onUpdate:modelValue": _cache[100] || (_cache[100] = ($event: any) => ((_ctx.specOptions.description) = $event)),
                      onInput: _cache[101] || (_cache[101] = ($event: any) => (_ctx.specOptions.description=_ctx.specOptions.description.replace(/[^0-9-]/g,''))),
                      placeholder: "请输入规格描述"
                    }, {
                      append: _withCtx(() => _cache[165] || (_cache[165] = [
                        _createTextVNode("人食")
                      ])),
                      _: 1
                    }, 8, ["modelValue"]),
                    _cache[166] || (_cache[166] = _createElementVNode("div", { class: "tips" }, "注：规格描述请填写适合食用人数 ，例如：2-3人食", -1))
                  ]),
                  _: 1
                }))
              : (_ctx.formData.cat_id != 5)
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 7,
                    label: "规格描述："
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "textarea",
                        modelValue: _ctx.specOptions.description,
                        "onUpdate:modelValue": _cache[102] || (_cache[102] = ($event: any) => ((_ctx.specOptions.description) = $event)),
                        modelModifiers: { trim: true },
                        autocomplete: "off",
                        maxlength: "100",
                        row: 4,
                        "show-word-limit": "",
                        onBlur: _cache[103] || (_cache[103] = ($event: any) => (_ctx.specOptions.description = _ctx.clearBr(_ctx.specOptions.description)))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"]),
    _createVNode(_component_el_dialog, {
      title: "收费附件",
      modelValue: _ctx.chargeDialog,
      "onUpdate:modelValue": _cache[117] || (_cache[117] = ($event: any) => ((_ctx.chargeDialog) = $event)),
      width: "70%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_81, [
          _createVNode(_component_el_button, {
            onClick: _cache[115] || (_cache[115] = ($event: any) => (_ctx.chargeDialog = false))
          }, {
            default: _withCtx(() => _cache[170] || (_cache[170] = [
              _createTextVNode("取 消")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[116] || (_cache[116] = ($event: any) => (_ctx.submitCharge()))
          }, {
            default: _withCtx(() => _cache[171] || (_cache[171] = [
              _createTextVNode("确 定")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.chargeOptions,
          ref: "addChargeFrom",
          "label-width": "120px",
          rules: _ctx.chargeRules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "类型",
              prop: "is_candle"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.chargeOptions.is_candle,
                  "onUpdate:modelValue": _cache[107] || (_cache[107] = ($event: any) => ((_ctx.chargeOptions.is_candle) = $event)),
                  width: "200",
                  onChange: _ctx.handleCandleChange
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "其他配件",
                      value: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "数字蜡烛",
                      value: 2
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"]),
                (_ctx.chargeOptions.is_candle == 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_78, "注意：数字蜡烛为0-9"))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "附件名称：",
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.chargeOptions.name,
                  "onUpdate:modelValue": _cache[108] || (_cache[108] = ($event: any) => ((_ctx.chargeOptions.name) = $event)),
                  autocomplete: "off",
                  disabled: _ctx.chargeOptions.id!=='' && (_ctx.formData.product_id>0 || _ctx.ProductO[_ctx.o]==='已上线') || _ctx.chargeOptions.is_candle == 2
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "计量单位：",
              prop: "unity"
            }, {
              default: _withCtx(() => [
                (_ctx.chargeOptions.is_candle == 2)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_79, "个"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_80, "份"))
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "单价：",
              prop: "price"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.chargeOptions.price,
                  "onUpdate:modelValue": _cache[109] || (_cache[109] = ($event: any) => ((_ctx.chargeOptions.price) = $event)),
                  onInput: _ctx.formatPrice,
                  autocomplete: "off"
                }, null, 8, ["modelValue", "onInput"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              style: {"margin":"35px 0px"},
              label: "附件图标：",
              prop: "type",
              required: ""
            }, {
              default: _withCtx(() => [
                (_ctx.chargeOptions.is_candle==1)
                  ? (_openBlock(), _createBlock(_component_el_radio_group, {
                      key: 0,
                      modelValue: _ctx.chargeOptions.type,
                      "onUpdate:modelValue": _cache[110] || (_cache[110] = ($event: any) => ((_ctx.chargeOptions.type) = $event)),
                      class: "ml-4",
                      style: {"flex-wrap":"nowrap"},
                      disabled: _ctx.chargeOptions.is_candle == 2
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.radioTypes, (type) => {
                          return (_openBlock(), _createBlock(_component_el_radio, {
                            style: {"display":"flex","flex-direction":"column-reverse","justify-content":"flex-end","align-items":"center"},
                            key: type,
                            label: type,
                            size: "large"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", {
                                class: _normalizeClass(`icon type-${type}`),
                                style: {"margin-bottom":"10px"}
                              }, null, 2)
                            ]),
                            _: 2
                          }, 1032, ["label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "disabled"]))
                  : (_openBlock(), _createBlock(_component_el_radio_group, {
                      key: 1,
                      modelValue: _ctx.chargeOptions.type,
                      "onUpdate:modelValue": _cache[111] || (_cache[111] = ($event: any) => ((_ctx.chargeOptions.type) = $event)),
                      class: "ml-4",
                      style: {"flex-wrap":"nowrap"},
                      disabled: _ctx.chargeOptions.is_candle == 2
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio, {
                          label: 4,
                          size: "large",
                          style: {"display":"flex","flex-direction":"column-reverse","justify-content":"flex-end","align-items":"center"}
                        }, {
                          default: _withCtx(() => _cache[169] || (_cache[169] = [
                            _createElementVNode("div", {
                              class: "icon type-4",
                              style: {"margin-bottom":"10px"}
                            }, null, -1)
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue", "disabled"]))
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              style: {"margin":"35px 0px"},
              label: "SKU",
              prop: "sku"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.chargeOptions.sku,
                  "onUpdate:modelValue": _cache[112] || (_cache[112] = ($event: any) => ((_ctx.chargeOptions.sku) = $event)),
                  placeholder: "请输入SKU",
                  onInput: _cache[113] || (_cache[113] = ($event: any) => (_ctx.chargeOptions.sku = _ctx.chargeOptions.sku.replace(/[^0-9a-zA-Z_\-.!@#$%^&*()+,?/]/g, ''))),
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "状态：",
              prop: "status"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.chargeOptions.status,
                  "onUpdate:modelValue": _cache[114] || (_cache[114] = ($event: any) => ((_ctx.chargeOptions.status) = $event)),
                  width: "200"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "上架",
                      value: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "下架",
                      value: 0
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_AutoDetailsImg, {
      ref: "AutoDetailsImg",
      onAddImage: _ctx.loadAndAddImage
    }, null, 8, ["onAddImage"])
  ]))
}